"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BeaconGlobalStyle: true,
  contrast: true,
  escapeCss: true,
  getRGBAValue: true,
  hexToRGB: true
};
Object.defineProperty(exports, "BeaconGlobalStyle", {
  enumerable: true,
  get: function get() {
    return _GlobalStyle.BeaconGlobalStyle;
  }
});
Object.defineProperty(exports, "contrast", {
  enumerable: true,
  get: function get() {
    return _contrast.contrast;
  }
});
Object.defineProperty(exports, "escapeCss", {
  enumerable: true,
  get: function get() {
    return _escapeCss.escapeCss;
  }
});
Object.defineProperty(exports, "getRGBAValue", {
  enumerable: true,
  get: function get() {
    return _getRGBAValue.getRGBAValue;
  }
});
Object.defineProperty(exports, "hexToRGB", {
  enumerable: true,
  get: function get() {
    return _hexToRGB.hexToRGB;
  }
});
exports["default"] = void 0;

var _BeaconThemeProvider = require("./components/BeaconThemeProvider");

var _GlobalStyle = require("./components/GlobalStyle");

var _borderRadius = require("./services/borderRadius");

Object.keys(_borderRadius).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _borderRadius[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _borderRadius[key];
    }
  });
});

var _borderWidth = require("./services/borderWidth");

Object.keys(_borderWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _borderWidth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _borderWidth[key];
    }
  });
});

var _breakpoint = require("./services/breakpoint");

Object.keys(_breakpoint).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _breakpoint[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _breakpoint[key];
    }
  });
});

var _color = require("./services/color");

Object.keys(_color).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _color[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _color[key];
    }
  });
});

var _intentColor = require("./services/intentColor");

Object.keys(_intentColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _intentColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _intentColor[key];
    }
  });
});

var _fontFamily = require("./services/fontFamily");

Object.keys(_fontFamily).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fontFamily[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fontFamily[key];
    }
  });
});

var _fontSize = require("./services/fontSize");

Object.keys(_fontSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fontSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fontSize[key];
    }
  });
});

var _fontWeight = require("./services/fontWeight");

Object.keys(_fontWeight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fontWeight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fontWeight[key];
    }
  });
});

var _shadow = require("./services/shadow");

Object.keys(_shadow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shadow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shadow[key];
    }
  });
});

var _spacing = require("./services/spacing");

Object.keys(_spacing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _spacing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _spacing[key];
    }
  });
});

var _contrast = require("./services/contrast");

Object.keys(_contrast).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _contrast[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _contrast[key];
    }
  });
});

var _escapeCss = require("./services/escapeCss");

Object.keys(_escapeCss).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _escapeCss[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _escapeCss[key];
    }
  });
});

var _getRGBAValue = require("./services/getRGBAValue");

Object.keys(_getRGBAValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getRGBAValue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getRGBAValue[key];
    }
  });
});

var _hexToRGB = require("./services/hexToRGB");

Object.keys(_hexToRGB).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hexToRGB[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hexToRGB[key];
    }
  });
});

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
// export global styles
// selector exports
// export services defaults
// export services named exports
// export types
// eslint-disable-next-line import/no-default-export
var _default = _BeaconThemeProvider.BeaconThemeProvider;
exports["default"] = _default;